import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import SmartsAPI from 'dashboard/api/smart';

const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isDeleting: false,
        isUpdating: false,
    },
    lists: []
};

export const getters = {
    getUIFlags(_state) {
        return _state.uiFlags;
    },
    getSmart(_state) {
        return _state.records;
    }
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.default.SET_SMART_UI_FLAG, { isFetching: true });
        try {
            const response = await SmartsAPI.get();
            commit(types.default.SET_SMART, response.data);
        } catch (error) {
            // Ignore error
        } finally {
            commit(types.default.SET_SMART_UI_FLAG, { isFetching: false });
        }
    },

    update: async ({ commit }, { id, ...updateObj }) => {
        commit(types.default.SET_SMART_UI_FLAG, { isUpdating: true });
        if (id) {
            var response = await SmartsAPI.update(id, updateObj);
        } else {
            var response = await SmartsAPI.create(updateObj);
        }
        commit(types.default.UPDATE_SMART, response.data);
        commit(types.default.SET_SMART_UI_FLAG, { isUpdating: false });
    },

    setSmart: async ({ commit }, search) => {
        try {
          const response = await SmartsAPI.search(search);
          state.lists = response.data;
        } catch (error) {
          // Handle error
        }
      },
};

export const mutations = {
    [types.default.SET_SMART_UI_FLAG](_state, data) {
        _state.uiFlags = {
            ..._state.uiFlags,
            ...data,
        };
    },
    [types.default.SET_SMART]: MutationHelpers.set,
    [types.default.UPDATE_SMART]: MutationHelpers.update,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
